import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import StatsItem from './StatsItem';
import { localizations } from '../../localization/localization';
import ListImgThumbnail from '../../images/logos/screenCaptures/Luettelo-thumbnail.png';
import ListImg from '../../images/logos/screenCaptures/Luettelo.png';
import PopupUnitImgThumbnail from '../../images/logos/screenCaptures/Popup-ilmoitus-thumbnail.png';
import PopupUnitImg from '../../images/logos/screenCaptures/Popup-ilmoitus.png';
import PopupCompanyImgThumbnail from '../../images/logos/screenCaptures/Popup-yritys-thumbnail.png';
import PopupCompanyImg from '../../images/logos/screenCaptures/Popup-yritys.png';
import RouteImgThumbnail from '../../images/logos/screenCaptures/Reitti-thumbnail.png';
import RouteImg from '../../images/logos/screenCaptures/Reitti.png';
import TooltipImgThumbnail from '../../images/logos/screenCaptures/Tooltip-thumbnail.png';
import TooltipImg from '../../images/logos/screenCaptures/Tooltip.png';
import WidgetImgThumbnail from '../../images/logos/screenCaptures/widget-thumbnail.png';
import WidgetImg from '../../images/logos/screenCaptures/widget.png';

const styles = (theme: Theme) => createStyles({
  screenCaptureContainer: {
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    backgroundColor: '#022639',
    padding: '1.6875em',
    paddingTop: '1.375em',
    paddingBottom: '1.375em',
    [theme.breakpoints.down('sm')]: {
      padding: '3em',
    },
    marginTop: '4.375em'
  },
  screenCaptureBox: {
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.2941em'
    },
  },
  screenCaptureBoxMobile: {
    '& > div:first-child': {
      color: 'white',
      fontSize: '1.6em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.2941em'
    },
  },
  mediaLogoUsageContainer: {
    justifyContent: 'flex-start',
    paddingLeft: '0.25em',
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.323em',
      marginTop: 30
    },
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      paddingLeft: '4.688em',
      flex: 1
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    }
  },
  mediaLogoLink: {
    color: theme.palette.secondary.main,
    cursor: 'pointer',
    paddingLeft: '2.25em',
  },
  imageBoxContainer: {
    maxWidth: 320,
    paddingTop: 20,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  imageBoxContainerMobile: {
    maxWidth: 220,
    paddingTop: 15,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  imageBox: {
    width: 300,
    height: 200,
    cursor: 'pointer',
  },
  imageBoxMobile: {
    width: 200,
    height: 150,
    cursor: 'pointer',
  },
  dialogImage: {
    cursor: 'pointer'
  }
});

const ScreenCaptureContainer: React.FunctionComponent<WithStyles & { isMobile?: boolean; }> = ({
  classes, isMobile
}) => {
  const [selectedImage, setSelectedImage] = React.useState('');
  
  return (
    <>
      <Grid item container direction="column" className={classes.screenCaptureContainer}>
        <Grid item container direction="column" className={isMobile === false ? classes.screenCaptureBox : classes.screenCaptureBoxMobile}>
          <Grid item>{localizations.mediaPageView.screenCaptures}</Grid>
          <Grid item>
            <p>{localizations.mediaPageView.screenCapturesParagraph01}</p>
          </Grid>
        </Grid>
        <Grid item container direction="row">
          <Grid item container direction="column" className={isMobile === false ? classes.imageBoxContainer : classes.imageBoxContainerMobile}>
            <img src={ListImgThumbnail} className={isMobile === false ? classes.imageBox : classes.imageBoxMobile} onClick={() => setSelectedImage(ListImg)} />
            <p><a className={classes.mediaLogoLink} href={ListImg} download>Luettelo.png</a></p>
          </Grid>
          <Grid item container direction="column" className={isMobile === false ? classes.imageBoxContainer : classes.imageBoxContainerMobile}>
            <img src={PopupUnitImgThumbnail} className={isMobile === false ? classes.imageBox : classes.imageBoxMobile} onClick={() => setSelectedImage(PopupUnitImg)} />
            <p><a className={classes.mediaLogoLink} href={PopupUnitImg} download>Popup-ilmoitus.png</a></p>
          </Grid>
          <Grid item container direction="column" className={isMobile === false ? classes.imageBoxContainer : classes.imageBoxContainerMobile}>
            <img src={PopupCompanyImgThumbnail} className={isMobile === false ? classes.imageBox : classes.imageBoxMobile} onClick={() => setSelectedImage(PopupCompanyImg)} />
            <p><a className={classes.mediaLogoLink} href={PopupCompanyImg} download>Popup-yritys.png</a></p>
          </Grid>
        </Grid>
        <Grid item container direction="row">
          <Grid item container direction="column" className={isMobile === false ? classes.imageBoxContainer : classes.imageBoxContainerMobile}>
            <img src={RouteImgThumbnail} className={isMobile === false ? classes.imageBox : classes.imageBoxMobile} onClick={() => setSelectedImage(RouteImg)} />
            <p><a className={classes.mediaLogoLink} href={RouteImg} download>Reitti.png</a></p>
          </Grid>
          <Grid item container direction="column" className={isMobile === false ? classes.imageBoxContainer : classes.imageBoxContainerMobile}>
            <img src={TooltipImgThumbnail} className={isMobile === false ? classes.imageBox : classes.imageBoxMobile} onClick={() => setSelectedImage(TooltipImg)} />
            <p><a className={classes.mediaLogoLink} href={TooltipImg} download>Tooltip.png</a></p>
          </Grid>
          <Grid item container direction="column" className={isMobile === false ? classes.imageBoxContainer : classes.imageBoxContainerMobile}>
            <img src={WidgetImgThumbnail} className={isMobile === false ? classes.imageBox : classes.imageBoxMobile} onClick={() => setSelectedImage(WidgetImg)} />
            <p><a className={classes.mediaLogoLink} href={WidgetImg} download>Widget.png</a></p>
          </Grid>
        </Grid>
      </Grid>
      <Dialog open={selectedImage !== ''} onClose={() => setSelectedImage('')} maxWidth="lg">
        <img src={selectedImage} className={classes.dialogImage} onClick={() => setSelectedImage('')} />
      </Dialog>
    </>
  );
}

export default withStyles(styles)(ScreenCaptureContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/ScreenCaptureContainer.tsx